import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputNumber } from 'primereact/inputnumber';

interface IMassEmbryoCreationDialogProps {
  visible: boolean;
  onHide: () => void;
  grade1: number;
  grade2: number;
  onGrade1Change: (value: number) => void;
  onGrade2Change: (value: number) => void;
  onAccept: () => void;
}

export const MassEmbryoCreationDialog: React.FC<
  IMassEmbryoCreationDialogProps
> = ({
  visible,
  onHide,
  grade1,
  grade2,
  onGrade1Change,
  onGrade2Change,
  onAccept,
}) => {
  return (
    <ConfirmDialog
      visible={visible}
      onHide={onHide}
      message={
        <div className="create-embryo-button-dialog__buttons">
          <div>
            <div>Grade 1</div>
            <InputNumber
              value={grade1}
              onValueChange={(e) => onGrade1Change(e.value as number)}
              showButtons
            />
          </div>
          <div>
            <div>Grade 2</div>
            <InputNumber
              value={grade2}
              onValueChange={(e) => onGrade2Change(e.value as number)}
              showButtons
            />
          </div>
        </div>
      }
      header="Mass Embryo Creation Dialog"
      accept={onAccept}
      acceptLabel="Confirm"
      rejectLabel="Cancel"
    />
  );
};
